import { getMembership } from '../membership/getMembership';
import { isMemberOfOrganization } from '../organization/isMemberOfOrganization';
import { isPremOrganizationAdmin } from '../organization/isPremOrganizationAdmin';
import { allowsSelfJoin } from './allowsSelfJoin';

/**
 * This ports the `canJoin` method from `app/scripts/models/Board`, which
 * relied on model cache data.
 */
export const canJoin = (
  member: {
    id: string;
    idEnterprisesAdmin: Array<string>;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  },
  board: {
    idEnterprise?: string | null;
    memberships: {
      id: string;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
    }[];
    organization?: { id: string } | null;
    prefs?: { isTemplate: boolean; selfJoin: boolean } | null;
  },
  workspace:
    | ({ id: string; offering: string } & {
        idEnterprise?: string | null;
        enterprise?: { id: string } | null;
        memberships: {
          id: string;
          deactivated: boolean;
          idMember: string;
          memberType: 'admin' | 'normal';
          unconfirmed: boolean;
        }[];
      })
    | null,
  enterprise: ({ idAdmins: Array<string> } & { id: string }) | null,
): boolean => {
  if (!workspace && !board.idEnterprise) {
    return false;
  }

  // Any board member type (admin, normal, or observer) can't join a board
  const memberType = getMembership(board.memberships, member.id);
  if (memberType) {
    return false;
  }

  const isPremOrgAdmin =
    workspace && isPremOrganizationAdmin(member, workspace.id);
  const selfJoin = allowsSelfJoin(board);

  const isEnterpriseBoard =
    !!board.idEnterprise || (workspace && !!workspace.enterprise);

  const isOrgMember =
    workspace && isMemberOfOrganization(member, workspace, enterprise);
  return Boolean(
    isPremOrgAdmin ||
    (selfJoin && isOrgMember) ||
    (isEnterpriseBoard && enterprise?.idAdmins?.includes(member.id)),
  );
};
